// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2k7fu","title":"InfoRow_title__2JOVk"};